import $ from 'jquery';
import * as Api from '../utils/api';
import * as Ui from '../utils/uiUtils';

export async function refreshContactGroups() {
  $('#item-contact-group').val(null).trigger('change');
  const contactGroups = await Api.getContactGroups();
  Ui.renderOptions(contactGroups, '#item-contact-group', false);
  $('#selectBox').show();
}

export async function refreshConfidentialities() {
  const confidentialities = await Api.getConfidentialities();
  Ui.renderOptions(confidentialities, '#item-confidential', true);
}

export async function refreshUsers() {
  const users = await Api.getUsers();
  Ui.renderOptions(users, '#item-assigned-to', true);

  $('#item-communication').trigger('change');
}

export async function refreshPriorities() {
  const priorities = await Api.getPriorities();
  Ui.renderOptions(priorities, '#complaint-priorities', true);

  $('#item-communication').trigger('change');
}

export async function refreshComplaintStatuses() {
  const statuses = await Api.getStatuses();
  Ui.renderOptions(statuses, '#item-complaint-status', false);

  $('#item-communication').trigger('change');
}

export async function refreshInteractionTypes() {
  const interactionTypes = await Api.getInteractionTypes();
  Ui.renderOptions(interactionTypes, '#item-interaction-type', false);
}

export async function refreshInteractionTags() {
  const tags = await Api.getInteractionTags();
  Ui.renderOptions(tags, '#item-tag', false);
}
